export default __webpack_public_path__ + "static/olhar-digital-header-logo-6652a5bc629c65e1d7cd948e31908e3e.png";